(() => {
const start = () => {
 const dialog = document.querySelector('[data-mox-welcome]');
 if (!dialog || dialog.dataset.initialized === 'true') return;
 dialog.dataset.initialized = 'true';
 const forced = new URL(location.href).searchParams.get('mox_popup_preview') === '1';
 const editor = dialog.dataset.editor === 'true';
 const ready = dialog.dataset.ready === 'true';
 const eligible = dialog.dataset.eligible === 'true';
 const automaticAllowed = !matchMedia('(max-width:749px)').matches;
 const submittedHere = location.hash === '#MoxcardsWelcome';
 const success = submittedHere && ready && !editor && !!dialog.querySelector('[data-welcome-success]');
 const error = submittedHere && ready && !editor && !!dialog.querySelector('[data-welcome-error]');
 const key = 'moxcards_welcome_dismissed_v4';
 let dismissed = false, attempts = 0, timer;
 try { dismissed = localStorage.getItem(key) === '1'; } catch (_) { try { dismissed = sessionStorage.getItem(key) === '1'; } catch (_) {} }
 const note = dialog.querySelector('[data-welcome-test]');
 if (note) note.hidden = ready && !editor;
 if (note && ready && editor) note.textContent = document.documentElement.lang.toLowerCase().startsWith('fr') ? 'APERÇU DE L’ÉDITEUR — Les inscriptions sont désactivées dans cet aperçu. La popup est activée dans les réglages du thème ; cet aperçu ne vérifie pas la livraison du code par e-mail.' : 'EDITOR PREVIEW — Signups are disabled in this preview. The popup is enabled in the theme settings; this preview does not verify email delivery of the code.';
 let previousFocus;
 let bannerCache = null;
 let bannerObserver;
 const bannerSelector = '#shopify-pc__banner, #shopify-pc__prefs, .shopify-pc__banner';
 const invalidateBanner = () => { bannerCache = null; };
 const watchBanner = () => {
  if (bannerObserver) return;
  bannerObserver = new MutationObserver(records => {
   if (!bannerCache) return;
   if (records.some(record => {
    const target = record.target;
    if (!(target instanceof Element)) return false;
    if (target.matches('style, link') || target.closest('style') || bannerCache.nodes.some(node => target === node || target.contains(node) || node.contains(target))) return true;
    return [...record.addedNodes, ...record.removedNodes].some(node => node instanceof Element && (node.matches(bannerSelector + ', style, link') || node.querySelector(bannerSelector + ', style, link')));
   })) invalidateBanner();
  });
  bannerObserver.observe(document.documentElement, {attributes:true, childList:true, subtree:true});
  window.addEventListener('resize', invalidateBanner, {passive:true});
  document.addEventListener('load', invalidateBanner, true);
  document.addEventListener('transitionend', invalidateBanner, true);
  document.addEventListener('animationend', invalidateBanner, true);
 };
 const stopBannerWatch = () => { bannerObserver?.disconnect(); bannerObserver = null; invalidateBanner(); };
 const bannerVisible = () => {
  watchBanner();
  if (bannerCache) return bannerCache.visible;
  const nodes = [...document.querySelectorAll(bannerSelector)];
  const visible = nodes.some(node => node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden');
  bannerCache = {nodes, visible};
  return visible;
 };
 const blocked = () => {
  if (document.querySelector('dialog[open]:not(#MoxcardsWelcome)')) return true;
  const privacy = window.Shopify?.customerPrivacy;
  const consent = privacy?.currentVisitorConsent?.();
  // A pending consent decision already blocks the welcome dialog. Avoid forcing
  // banner layout until its geometry is actually needed to decide.
  if (privacy?.shouldShowBanner?.() && consent && consent.analytics === '' && consent.marketing === '' && consent.preferences === '') return true;
  return bannerVisible();
 };
 const open = () => {
  if (dialog.open || !dialog.isConnected || typeof dialog.showModal !== 'function') return;
  if (blocked()) {
   if (++attempts < 20) timer = setTimeout(open, 1000);
   else stopBannerWatch();
   return;
  }
  stopBannerWatch();
  previousFocus = document.activeElement;
  dialog.showModal();
 };
 const close = () => {
  stopBannerWatch();
  clearTimeout(timer);
  if (!forced && !editor) { dismissed = true; try { localStorage.setItem(key, '1'); } catch (_) { try { sessionStorage.setItem(key, '1'); } catch (_) {} } }
  dialog.close();
  previousFocus?.focus?.({preventScroll:true});
 };
 dialog.querySelector('[data-welcome-close]')?.addEventListener('click', close);
 dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
 dialog.addEventListener('click', event => {
  if (event.target !== dialog) return;
  const rect = dialog.getBoundingClientRect();
  if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
 });
 if (!ready || editor) dialog.querySelector('form')?.addEventListener('submit', event => event.preventDefault());
 if (success) { try { localStorage.setItem(key, '1'); } catch (_) {} }
 document.addEventListener('visitorConsentCollected', () => {
  invalidateBanner();
  if (!dismissed && (forced || editor || success || error || (ready && eligible && automaticAllowed))) {
   attempts = 0;
   clearTimeout(timer);
   timer = setTimeout(open, 1000);
  }
 });
 if (forced || editor || success || error) open();
 else if (ready && eligible && automaticAllowed && !dismissed) timer = setTimeout(open, Math.max(5000, Number(dialog.dataset.delay) || 7000));
};
const reachNewsletter = () => {
 const target = document.querySelector('[data-mox-newsletter]');
 if (!target) return;
 target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'center'});
 target.querySelector('input[type=email]')?.focus({preventScroll:true});
};
document.addEventListener('click', event => {
 const link = event.target.closest('a[href]');
 if (!link) return;
 const target = new URL(link.href, location.href);
 if (target.origin === location.origin && target.pathname === location.pathname && target.hash === '#moxcards-newsletter' && document.querySelector('[data-mox-newsletter]')) {
  event.preventDefault();
  reachNewsletter();
 }
});
const initialize = () => {start();if (location.hash === '#moxcards-newsletter') reachNewsletter();};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true}); else initialize();
document.addEventListener('shopify:section:load', start);
})();
